import endpoints from "hooks/api/endpoints";
import useApiGet from "hooks/api/useApiGet";
import { useEffect, useState } from "react";

export default function useValidateToken(token: string | null) {
  const [isTokenValid, setIsTokenValid] = useState(false);
  const { result, error, isLoading } = useApiGet(
    token ? endpoints.getVerifyPasswordToken(token) : "",
  );

  useEffect(() => {
    if (result) {
      setIsTokenValid(true);
    }
  }, [result]);

  return {
    isLoading,
    error,
    isTokenValid,
  };
}
